export default __webpack_public_path__ + "static/media/check.a1901263.png";